module.exports = __webpack_public_path__ + "images/underweight.476121aa4bc5552023d1687ff0fb436d.png";